import * as React from 'react'
import { FC, useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

type Props = RouteComponentProps & {
  children: any
  location: any
}
export const WithTracker: FC<Props> = ({ children, location }) => {
  const trackPage = (page: string) => {
    if (window.HubSpotConversations) {
      const status = window.HubSpotConversations.widget.status()
      if (status.loaded) {
        window.HubSpotConversations.widget.refresh()
      }
    }
  }

  useEffect(() => {
    let page = location && location.pathname && location.pathname
    if (location && location.search) page += location.search
    trackPage(page)
  }, [location])

  return <>{children}</>
}

export default withRouter(WithTracker)
